import React from 'react';
import { Users, CreditCard, Smartphone, Bus, MapPin, BarChart3 } from 'lucide-react';

const FeaturesSection = () => {
  const features = [
    {
      icon: Users,
      title: "Gestão de Passageiros",
      description: "Cadastros completos de condomínios, blocos, unidades e passageiros",
      details: [
        "Pré-cadastro online de passageiros",
        "Controle centralizado de autorizados",
        "Gestão por unidade habitacional",
        "Eliminação de não autorizados"
      ],
      color: "from-[#007bff] to-[#0056b3]"
    },
    {
      icon: CreditCard,
      title: "Credenciais NFC",
      description: "Cartões físicos e virtuais com tecnologia NFC de última geração",
      details: [
        "Credenciais físicas e virtuais",
        "Integração com gráfica",
        "Envio de mensagens por WhatsApp, Email e App",
        "Redução de custos logísticos"
      ],
      color: "from-[#008080] to-[#006666]"
    },
    {
      icon: Smartphone,
      title: "App do Motorista",
      description: "Aplicativo dedicado com validação remota e alertas inteligentes",
      details: [
        "Foto do passageiro em tempo real",
        "Mensagens visuais e por voz",
        "Validação via NFC/Bluetooth",
        "Registro automático de embarques"
      ],
      color: "from-[#007bff] to-[#008080]"
    },
    {
      icon: MapPin,
      title: "App do Condômino",
      description: "Experiência completa para usuários do transporte",
      details: [
        "Consulta de horários e rotas",
        "Credencial virtual no celular",
        "Georreferenciamento em tempo real"
      ],
      color: "from-[#0056b3] to-[#007bff]"
    },
    {
      icon: Bus,
      title: "Gestão de Frota e Rotas",
      description: "Controle operacional completo e otimização de recursos",
      details: [
        "Cadastro de frota e rotas",
        "Pontos de embarque mapeados",
        "Mapa de calor por bairros",
        "Otimização de horários"
      ],
      color: "from-[#008080] to-[#007bff]"
    },
    {
      icon: BarChart3,
      title: "Relatórios e Dashboards",
      description: "Dados confiáveis para tomada de decisão e prestação de contas",
      details: [
        "Relatórios operacionais e gerenciais",
        "Dashboards visuais em tempo real",
        "Auditoria completa de eventos",
        "Evidências para renovações"
      ],
      color: "from-[#0056b3] to-[#008080]"
    }
  ];

  return (
    <section id="funcionalidades" className="py-24 bg-gradient-to-b from-white to-gray-50">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-[#007bff]/10 px-4 py-2 rounded-full border border-[#007bff]/20 mb-6">
            <BarChart3 className="w-4 h-4 text-[#007bff]" />
            <span className="text-sm font-medium text-[#007bff]">Funcionalidades</span>
          </div>
          
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            Funcionalidades Completas
          </h2>
          <p className="text-xl text-gray-600">
            Tecnologia de ponta para governança total do transporte condominial
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
          {features.map((feature, index) => {
            const Icon = feature.icon;
            return (
              <div 
                key={index}
                className="group relative bg-white rounded-3xl shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden border border-gray-100 hover:border-transparent hover:-translate-y-2"
              >
                {/* Gradient header */}
                <div className={`bg-gradient-to-r ${feature.color} p-8 relative overflow-hidden`}>
                  <div className="absolute top-0 right-0 w-32 h-32 bg-white/10 rounded-full -mr-16 -mt-16"></div>
                  <div className="absolute bottom-0 left-0 w-24 h-24 bg-white/10 rounded-full -ml-12 -mb-12"></div>
                  
                  <div className="relative">
                    <div className="w-16 h-16 rounded-2xl bg-white/20 backdrop-blur-sm flex items-center justify-center mb-4">
                      <Icon className="w-8 h-8 text-white" />
                    </div>
                    
                    <h3 className="text-2xl font-bold text-white mb-2">
                      {feature.title}
                    </h3>
                  </div>
                </div>

                {/* Content */}
                <div className="p-8">
                  <p className="text-gray-600 mb-6 leading-relaxed">
                    {feature.description}
                  </p>
                  
                  <ul className="space-y-3">
                    {feature.details.map((detail, idx) => (
                      <li key={idx} className="flex items-start gap-3">
                        <div className="flex-shrink-0 w-5 h-5 rounded-full bg-[#007bff]/10 flex items-center justify-center mt-0.5">
                          <div className="w-2 h-2 rounded-full bg-[#007bff]"></div>
                        </div>
                        <span className="text-gray-700 text-sm leading-relaxed">
                          {detail}
                        </span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
